import { render } from "./DynamicHtmlH5.vue?vue&type=template&id=0a845ccf&ts=true"
import script from "./DynamicHtmlH5.vue?vue&type=script&lang=ts"
export * from "./DynamicHtmlH5.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/entidades/builder/form/infrastructure/controls/editorTemplates/prime/DynamicHtmlH5.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a845ccf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a845ccf', __exports__)) {
    api.reload('0a845ccf', __exports__)
  }
  
  module.hot.accept("./DynamicHtmlH5.vue?vue&type=template&id=0a845ccf&ts=true", () => {
    api.rerender('0a845ccf', render)
  })

}


export default __exports__